export enum DocumentType {
  'Legal Notice' = 1,
  'Affidavit of Publication' = 2,
  'Hearing Summary' = 3,
  'Fiscal Impact Statement' = 4,
  'Explanatory Statement' = 5,
  'Misc' = 6,
  'Preamble' = 7,
  'Certificate of Adoption' = 8,
  'Hearing Notice' = 9,
  'Approval Packet' = 10,
  'Hearing Packet' = 11,
  'Submission Packet' = 12,
  'Gov Checklist' = 13,
  'Cover Letters and Statements' = 14,
}
